import { Box } from "@material-ui/core";
import Breadcrumbs from "components/Breadcrumbs";
import ComingSoon from "components/ComingSoon";
import SEO from "components/SEO";
import Text from "components/Text";
import { pagePadding } from "data/commonClasses";
import { twMerge } from "tailwind-merge";
import useTranslation from "translations/hooks/useTranslation";

export default function WebinarsSchedule(props) {
  const { t } = useTranslation();

  // let { session: { user: { _id, authToken }, lang } } = useContext(SessionContext);

  // function handleChange(e) {
  //     let { name, value } = e.target;
  //     setState({ [name]: value });
  // }

  // function handleFile(e) {
  //     var file = e.target.files[0];
  //     if (!file) return;
  //     var filesize = (file.size / 1024 / 1024).toFixed(4);
  //     if (filesize > 1) return;
  //     handleCreateFile(file, e)
  // }

  var breadcrumbs = [
    { text: t("home"), href: "/" },
    // { text: t('profile'), href: '/userProfile' },
    { text: t("webinarsSchedule") },
  ];

  return (
    <div className={twMerge("flex flex-col w-full min-h-screen", pagePadding)}>
      <SEO title={t("webinarsSchedule")} description={t("webinarsSchedule")} />
      <Breadcrumbs items={breadcrumbs} />
      <Text text={t("webinarsSchedule")} bold sectionTitle className="mt-5" />
      <ComingSoon />
    </div>
  );
}
